import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Crown } from 'lucide-react';

interface UpgradePromptProps {
  open: boolean;
  onClose: () => void;
  message: string;
}

export const UpgradePrompt: React.FC<UpgradePromptProps> = ({
  open,
  onClose,
  message,
}) => {
  const navigate = useNavigate();

  const handleViewPlans = () => {
    onClose();
    navigate('/pricing');
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-wedding-text-title">
            <Crown className="h-5 w-5 text-wedding-gold" />
            升級方案
          </DialogTitle>
          <DialogDescription className="text-wedding-text-body">
            {message}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={onClose}>
            稍後再說
          </Button>
          <Button
            onClick={handleViewPlans}
            className="bg-wedding-pink hover:bg-wedding-pink/90 text-white"
          >
            查看方案
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
